import { getEnv } from './environment';
import { ACTIVE_USER_EXISTS, INACTIVE_USER_EXISTS } from './constants';

const getLoginUrl = (errorCode: string, email?: string, cta?: string) => {
  const { loginUrl } = getEnv();
  const link = {
    type: '',
    url: '',
  };
  if (!errorCode) {
    return link;
  }
  if (errorCode === ACTIVE_USER_EXISTS) {
    link.type = 'active';
    link.url = `${loginUrl}/web-otp?email=${email || ''}`;
  } else if (errorCode === INACTIVE_USER_EXISTS) {
    link.type = 'inactive';
    link.url = `${loginUrl}/web-otp?email=${email || ''}&cta=${cta || ''}`;
  }
  return link;
};
export default getLoginUrl;
